import type { ButtonPresetIcon } from '@coorum-research/shared-common/types/component-design.type'
import type { ComponentPropsWithoutRef } from 'react'
import { ChatIcon } from './ChatIcon'
import { CrossIcon } from './CrossIcon'
import { EditIcon } from './EditIcon'
import { FileIcon } from './FileIcon'
import { StarIcon } from './StarIcon'
import { UserIcon } from './UserIcon'

type Props = ComponentPropsWithoutRef<'svg'> & {
  presetIcon?: ButtonPresetIcon
}

export function PresetIcon({ presetIcon, ...svgProps }: Props) {
  return (
    <>
      {presetIcon === 'edit' && <EditIcon {...svgProps} />}
      {presetIcon === 'talk' && <ChatIcon {...svgProps} />}
      {presetIcon === 'file' && <FileIcon {...svgProps} />}
      {presetIcon === 'star' && <StarIcon {...svgProps} />}
      {presetIcon === 'user' && <UserIcon {...svgProps} />}
      {presetIcon === 'cross' && <CrossIcon {...svgProps} />}
    </>
  )
}
